import { AssetModuleTable } from '@/asset/AssetModuleTable';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { ModuleInfo } from '@/common/model-apis/type';
import { Button } from 'antd';

export interface SpRecordListProps {
  value: any[];
  filterProps: any;
  activeKey: any;
  activeData: any;
  metaConfig: ModuleInfo;
  mainRecordValue: any;
  _headIdField?: string;
  headIdData?: string;
}

const SPFilterTable: React.FC<SpRecordListProps> = function SPFilterTable(props) {
  const {
    value = [],
    filterProps,
    activeKey,
    activeData,
    metaConfig,
    mainRecordValue,
    _headIdField,
    headIdData,
    ...otherProps
  } = props;

  const tableRef = useRef<any>();

  const getDownloadOption = () => {
    const url = filterProps.downloadField;
    if (url) {
      const downloadOption = {
        title: '操作',
        valueType: 'option',
        dataIndex: 'options',
        fixed: 'right',
        width: 140,
        align: 'center',
        render: (_text: any, record: any, index: number) => {
          return (
            <span>
              <Button
                type="link"
                onClick={() => {
                  window.open(record[url]);
                }}
              >
                下载
              </Button>
            </span>
          );
        },
      };
      return downloadOption;
    }
    return false;
  };

  return (
    <>
      <AssetModuleTable
        {...otherProps}
        key={activeKey || 'all'}
        value={value.filter((el: any) => activeKey && el[filterProps?.filterField] === activeKey)}
        ref={tableRef}
        rowDelable={false}
        optionColumns={getDownloadOption()}
        tableBaseMode="view"
        toolBarRender={[]}
      />
    </>
  );
};

export default SPFilterTable;
